import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { StorageService } from './storage.service';

@Injectable()
export class FeatureTogglerService {

  private featureToggle: any;
  constructor(
    private http: Http,
    private storageService: StorageService
  ) { }

  public loadFeatureToggler() {
    const featurePromise = this.http.get('./assets/toggle-feature.json')
    .map((feature: any) => {
      return feature.json();
    }).toPromise();
    featurePromise.then((feature) => {
      this.featureToggle = feature;
      this.storageService.setLocalItem('feature', JSON.stringify(feature));
    });
    return featurePromise;
  }

  public hasFeature(feature?: string): boolean {

    this.featureToggle = JSON.parse(this.storageService.getLocalItem('feature'));

    return this.findValue(this.featureToggle, feature, true);
  }

  private findValue(object, property, defaultValue) {
    if (!object || !property)  {
      return defaultValue;
    }
    property = property.split('.');
    property.forEach((key, index) => {
      if (!key || !object) {
        return defaultValue;
      }
      object = object[key];
    });
    return (object === undefined) ? defaultValue : object;
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/feature-toggler.service.ts